import { saneBoolean } from 'logard';
import moment from 'moment';
import { ROUTE_DATE_FORMAT } from '../planner/constants/general';
import CommonFilterType from '../shared/constants/CommonFilterType';
import { ContextLoader } from '../shared/models/AbstractContext';
import FilterService from '../shared/services/FilterService';
import { saneDate } from '../shared/utils/sanitizers';
import { present } from '../shared/utils/typescript';
import SurveyClient from './client/SurveyClient';
import { FOLLOWED_UP_FROM_PARAM, FOLLOWED_UP_TILL_PARAM, INCLUDE_FOLLOWED_UP_PARAM, ONLY_NEGATIVE_PARAM } from './constants/params';
import SurveyContext from './models/SurveyContext';
import SurveyFilters from './models/SurveyFilters';

const COMMON_FILTERS = [CommonFilterType.OUTLET_MULTIPLE];

export const surveyContextLoader = new ContextLoader(async s => {
  const common = await FilterService.getFilters(s, COMMON_FILTERS);
  const followedUpFrom = present(s.getQueryParam(FOLLOWED_UP_FROM_PARAM, saneDate, moment().subtract(7, 'days').format(ROUTE_DATE_FORMAT)));
  const followedUpTill = present(s.getQueryParam(FOLLOWED_UP_TILL_PARAM, saneDate, moment().format(ROUTE_DATE_FORMAT)));
  const includeFollowedUp = s.getQueryParam(INCLUDE_FOLLOWED_UP_PARAM, saneBoolean, false);
  const onlyNegative = s.getQueryParam(ONLY_NEGATIVE_PARAM, saneBoolean, false);

  const filters = new SurveyFilters(common, followedUpFrom, followedUpTill, includeFollowedUp, onlyNegative);

  const searchResult = await SurveyClient.searchForFollowUp(filters);

  return new SurveyContext(filters, searchResult);
});